import { Loading, SplitPanel } from '@components/atomic/atoms';
import CheckList from '@components/checklist/checkList';
import { UserContext } from '@components/contexts/UserProvider';
import UploadDocument from '@components/form/upload/uploadDocuments';
import { IcoClose } from '@icons';
import { getModalData } from '@lib/api';
// import { dateFormatter, formatToDecimals } from '@lib/helpers/formatting';
import { useQuery, useQueryClient } from '@tanstack/react-query';
// import moment from 'moment';
import React, { /*Fragment,*/ useContext, useState } from 'react';
import { Button, /*Col, Form,*/ Modal /*, Row*/ } from 'react-bootstrap';
import SummaryTenderModalInfo from './SummaryTenderModalInfo';
// import SummaryTenderModalCig from './SummaryTenderModalCig';
// import MassiveUpload from '@components/form/upload/massiveUpload';
import { ResumeChecklistProjectType } from './ResumeChecklistCellRenderer';
import SummaryDownloadList from './SummaryDownloadList';
import { useHasPermission } from '@lib/hooks/useHasPermission';

interface SummaryTenderModalProps {
	show: boolean;
	onHide: () => void;
	apiUrl: string;
	project: ResumeChecklistProjectType;
}

export type TenderDataType = {
	id: number;
	reported: boolean;
	reporting: boolean;
	supplierName?: string;
	number: string;
	company?: {
		id: number;
		name: string;
	};
	companyId?: number;
	tenderNumber?: string;
	subject?: string;
	callDate?: string;
	auctionImport?: number;
	totalImport?: number;
	import?: number;
	qualificationSystem?: string;
	assignmentProcedureCode?: string;
	tenderClassification?: string;
	assignmentCriteriaCode?: string;
	officialGazettePubItaly?: number;
	officialGazettePubEurope?: number;
	dedicated?: number;
	checkliststatus?: {
		color: string;
	};
};

const SummaryTenderModal: React.FC<SummaryTenderModalProps> = ({ show, onHide: onHideFromParent, apiUrl, project }) => {
	const { userAccess } = useContext(UserContext);

	const { data: modalData, isPending: isPendingModalData } = useQuery<{
		data: TenderDataType;
	}>({
		queryKey: ['modalData', apiUrl],
		queryFn: () => getModalData(apiUrl),
		enabled: show,
	});
	const tenderData = modalData?.data;

	const queryClient = useQueryClient();
	const invalidateInvoicesQuery = () => {
		queryClient.invalidateQueries({ queryKey: ['resumeInvoices'] });
	};

	const [isEdited, setIsEdited] = useState(false);
	const onHide = () => {
		if (isEdited) {
			invalidateInvoicesQuery();
		}
		setIsEdited(false);
		onHideFromParent();
	};

	const isDisabled = tenderData?.reported || tenderData?.reporting || (!userAccess.isPartner && !userAccess.isGuestEnteErogante);

	const shouldShowChecklist = useHasPermission('view-checklists');
	return (
		<Modal fullscreen show={show} onHide={onHide}>
			<Modal.Header
				style={{
					padding: '2rem',
					justifyContent: 'space-between',
				}}
			>
				<Modal.Title>
					<h2 style={{ fontSize: '28px', marginBottom: '0.5rem' }}>Controllo della procedura {tenderData?.id}</h2>
					<h3
						style={{
							fontSize: '18px',
							fontWeight: 700,
						}}
					>
						PROGETTO: {project.name}
					</h3>
				</Modal.Title>
				<Button
					className="btn custom-ghost-button"
					onClick={onHide}
					style={{
						color: 'var(--np-primary-color)',
						display: 'flex',
						alignItems: 'center',
						gap: '0.75rem',
					}}
				>
					Chiudi
					<IcoClose
						style={{
							fill: 'var(--np-primary-color)',
						}}
					/>
				</Button>
			</Modal.Header>
			<Modal.Body
				style={{
					padding: '2rem',
					overflow: 'hidden',
				}}
			>
				{isPendingModalData ? (
					<Loading />
				) : show ? (
					<SplitPanel
						panels={[
							{
								key: 'info',
								title: 'Informazioni',
								content: <SummaryTenderModalInfo tenderData={tenderData} />,
							},
							{
								key: 'documents',
								title: 'Documenti',
								content: (
									<div>
										<UploadDocument entity="tenders" entityId={tenderData.id} title="Documenti correlati" />
									</div>
								),
								...(shouldShowChecklist ? { defaultIsVisible: false } : {}),
							},
							...(shouldShowChecklist
								? [
										{
											key: 'checklist',
											title: 'Checklist',
											content: (
												<div className="custom-checklist-container">
													<div>
														<h4>Checklist per il controllo</h4>

														<SummaryDownloadList
															entity={{
																entityType: 'tenders',

																entityId: tenderData.id,
																label: 'procedure',
															}}
															hasStandardChecklist={tenderData.companyId === 2}

															// entityType="tenders"
															// entityId={tenderData.id}
															// label="procedure"
														/>
													</div>
													{tenderData.id && (
														<CheckList
															hasStandardChecklist={tenderData.companyId === 2}
															entityType="tenders"
															entityId={tenderData.id}
															disabled={isDisabled}
															hasInternalDownload={false}
															hasEnabledAi={project.aiEnabled}
														/>
													)}
												</div>
											),
										},
									]
								: []),
						]}
					/>
				) : null}
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={onHide} className="btn custom-outline-button custom-medium-button">
					Annulla
				</Button>
				{shouldShowChecklist ? (
					<Button
						onClick={() => {
							setIsEdited(true);
						}}
						disabled={isDisabled}
						type="submit"
						form="checklist-tenders"
						className="btn custom-primary-button custom-medium-button"
					>
						Salva risposte
					</Button>
				) : null}
			</Modal.Footer>
		</Modal>
	);
};

export default SummaryTenderModal;
